<template>
  <div id="client-doctor-login">
    <client-doctor-login-form />
  </div>
</template>

<script>
import ClientDoctorLoginForm from './components/ClientDoctorLoginForm.vue'

export default {
  name: 'ClientDoctorLogin',
  components: {
    ClientDoctorLoginForm
  }
}
</script>
